





































































import {
  defineComponent,
  ref,
  onMounted,
  watch,
  computed,
  onBeforeUnmount,
  useContext,
} from '@nuxtjs/composition-api'
import { defineProps } from '@/helpers/defineProps'
import textErrors from '@/validation/textErrors'

type InputFileProps = {
  id: string
  accept: string
  label: string
  placeholder: string
  withBorder: boolean
  error: boolean | string
  rules: string[]
  tooltip: string
  tooltipSrc: string
  tooltipText: string
  value: any
}

export default defineComponent({
  name: 'InputFile',
  props: defineProps<InputFileProps>({
    id: { default: '' },
    accept: { default: '' },
    label: { default: '' },
    placeholder: { default: '' },
    withBorder: { default: false },
    error: { default: false },
    rules: { default: () => [] as string[] },
    tooltip: { default: '' },
    tooltipSrc: { default: 'images/tooltipDoc.png' },
    tooltipText: { default: '' },
    value: { default: null },
  }),
  setup(props, ctx) {
    const dropArea = ref<HTMLInputElement>({} as HTMLInputElement)
    const model = ref<any>(props.value)
    const isActive = ref(false)
    const invalidFileType = ref('')
    const { app } = useContext()

    const acceptedFileTypes = computed(() =>
      props.accept
        ?.split(', ')
        ?.map((acceptFile) => acceptFile?.split('/').pop())
        ?.join(', ')
    )
    const src = computed(() => app.assetsPath + 'assets/' + props.tooltipSrc)
    const placeholderText = computed(
      () => `${props.placeholder} <br><span>Макс. размер файла - 15МБ</span>
        ${
          props.accept
            ? `<br><span>Доступные форматы для загрузки - ${acceptedFileTypes.value}</span>`
            : ''
        }`
    )

    watch(
      () => model.value,
      (val: string) => {
        if (val) {
          ctx.emit('input-change', model.value)
          ctx.emit('input', model.value)
        } else {
          ctx.emit('input-change', null)
          ctx.emit('input', null)
        }
      }
    )

    onMounted(() => {
      if (dropArea.value) {
        const arrEvents = ['dragenter', 'dragover', 'dragleave', 'drop']
        arrEvents.forEach((eventName) => {
          dropArea.value.addEventListener(eventName, preventDefaults, false)
        })
        ;['dragenter', 'dragover'].forEach((eventName) => {
          dropArea.value.addEventListener(eventName, highlight, false)
        })
        ;['dragleave', 'drop'].forEach((eventName) => {
          dropArea.value.addEventListener(eventName, unhighlight, false)
        })

        dropArea.value.addEventListener('drop', handleDrop, false)
      }
    })

    onBeforeUnmount(() => {
      if (dropArea.value) {
        ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
          dropArea.value.removeEventListener(eventName, preventDefaults, false)
        })
        ;['dragenter', 'dragover'].forEach((eventName) => {
          dropArea.value.removeEventListener(eventName, highlight, false)
        })
        ;['dragleave', 'drop'].forEach((eventName) => {
          dropArea.value.removeEventListener(eventName, unhighlight, false)
        })

        dropArea.value.removeEventListener('drop', handleDrop, false)
      }
    })

    const onInput = (val: any, i: any) => {
      invalidFileType.value = ''
      if (val) {
        const files = Array.isArray(val.target.files)
          ? val.target.files
          : Array.from(val.target.files)
        files.forEach((file: any) => {
          if (!props.accept) {
            model.value = file
          } else if (props.accept.includes(file.type)) {
            model.value = file
          } else {
            invalidFileType.value =
              textErrors.fileAccept + acceptedFileTypes.value
          }
        })
      } else {
        ctx.root.$delete(model.value, i)
        // model.value = null
      }
    }
    const handleDrop = (e: any) => {
      const dt = e.dataTransfer
      const files = dt.files
      handleFiles(files)
    }
    const handleFiles = (files: File[]) => {
      invalidFileType.value = ''
      Array.from(files).forEach(uploadFile)
    }
    const preventDefaults = (e: any) => {
      e.preventDefault()
      e.stopPropagation()
    }

    const uploadFile = (file: any) => {
      if (!props.accept || props.accept.split(', ').includes(file.type)) {
        model.value = file
      } else {
        invalidFileType.value = textErrors.fileAccept + acceptedFileTypes.value
      }
    }
    const highlight = () => {
      dropArea.value.classList.add('active')
    }
    const unhighlight = () => {
      dropArea.value.classList.remove('active')
    }

    const deleteFile = () => {
      model.value = null
      ctx.emit('input-change', model.value)
    }

    return {
      dropArea,

      invalidFileType,
      placeholderText,
      model,
      src,
      deleteFile,
      uploadFile,
      onInput,
      handleDrop,
      handleFiles,
      highlight,
      unhighlight,
      preventDefaults,
      isActive,
    }
  },
})
